import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';
import Client from '../../models/Client';


export interface ClientDetailState extends ApiState {
  client?: Client
}

export default requestReducer<ClientDetailState>('CLIENT_DETAIL')
